import React from "react";
import "./MultiStepProgressBar.scss";
import { ProgressBar, Step } from "react-step-progress-bar";

const MultiStepProgressBar = ({ page, onPageNumberClick,lastpagetick }) => {
  var stepPercentage = 0;
  if (page === "pageone") {
    stepPercentage = 0;
  } else if (page === "pagetwo") {
    stepPercentage = 50;
  } else if (page === "pagethree") {
    stepPercentage = 100;
  } else {
    stepPercentage = 0;
  }

  return (
    <ProgressBar percent={stepPercentage}>
      <Step>
        {({ accomplished, index }) => (
          <div
            className={`indexedStep ${accomplished ? "accomplished" : null}`}
            // onClick={() => onPageNumberClick("1")}
          >
            {
                page=="pagetwo" || page=="pagethree"?
                <img style={{width:"20px"}} src="./assets/images/ApplyOnlineImage/donetick.png" alt="" />
                :
                ""
            }
          </div>
        )}
      </Step>
      <Step>
        {({ accomplished, index }) => (
          <div
            className={`indexedStep ${accomplished ? "accomplished" : null}`}
            // onClick={() => onPageNumberClick("2")}
          >
            {
                page=="pagethree"?
                <img style={{width:"20px"}} src="./assets/images/ApplyOnlineImage/donetick.png" alt="" />
                :
                ""
            }
          </div>
        )}
      </Step>
      <Step>
        {({ accomplished, index }) => (
          <div
            className={`indexedStep ${accomplished ? "accomplished" : null}`}
            onClick={() => onPageNumberClick("3")}
          >
            {
              lastpagetick==1?
              <img style={{width:"20px"}} src="./assets/images/ApplyOnlineImage/donetick.png" alt="" />
                :
                ""
            }
            
          </div>
        )}
      </Step>
    </ProgressBar>
  );
};

export default MultiStepProgressBar;
